module.exports = __webpack_public_path__ + "static/logo-ryabko-3689eae0708d1eeea203775655ed1716.png";